module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAATlJREFUaEPtmD0OwjAMhe2eBBUmVjgASFSdWDkP10KtRC/ABkz8naRBFRKCAiVxksaJkjlx/Pm9OlYRPF/oef4QAVwrGBWICmhWIFpIs4Dax8NXQGyGEwCx1C4VJUBSV5jdqq6jnQqIYjADSLaUu42dqXGK+Xn3K17YAA211xYyZgOLgcLvQhaL9wwtytEYF6cj5S4WCogy3QMkKwoED4AiFYBwoEDwAWj8Q4DgBUCA4AegCPEXwPRDhvll3e42ovkG2kvSTg5GCVFhdp2/5vsVQFKJsAFszEK9WojyMlLOfFhI0v8PlzFYbwAKyfMDUEyeFwAheT4A3g9zvo/TOn2ERReyCmB6FlJKNv4X8v3Hlo1ZqFcLKV3maHP4XchRYaWvjQpIl8rSxqiApcJKh40KSJfK0kbvFbgDXsykMXCG9gEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/open.png
// module id = lHPd
// module chunks = 16